import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

export function YesNoField(props: {
  value: boolean
}) {
  return props.value ? <CheckCircleOutlineIcon /> : <HighlightOffIcon/>
}
